module.exports = __webpack_public_path__ + "static/media/dropzik-logo.03c2b148.png";